export const redirectToLogin = () => {
  sessionStorage.removeItem('accountantExternalId');
  window.location.assign(import.meta.env.VITE_WEBAPP_URL);
};
